import { Helmet } from 'react-helmet-async';

const siteUrl = process.env.REACT_APP_SITE_URL || 'https://varikanakku.com';
const productName = 'Varikanakku';
const defaultMetaDescription =
  'Varikanakku helps Indian businesses create GST invoices, manage parties and items, track ledgers, and prepare GST reports from one billbook.';

const SEOHead = ({
  title,
  absoluteTitle,
  description,
  keywords,
  image,
  imageAlt,
  url,
  type = 'website',
  structuredData,
  noindex = false,
}) => {
  const defaultTitle = `${productName} | Tax clarity. Total control.`;
  const defaultDescription = defaultMetaDescription;
  const defaultKeywords =
    'Varikanakku, GST billing software, invoice software India, e-invoice, e-way bill, GST reports, business ledger';
  const defaultImage = `${siteUrl}/og-image.svg`;
  const defaultImageAlt = `${productName} product preview`;

  const seoTitle = absoluteTitle || (title ? `${title} | ${productName}` : defaultTitle);
  const seoDescription = description || defaultDescription;
  const seoKeywords = keywords || defaultKeywords;
  const seoImage = image || defaultImage;
  const seoImageAlt = imageAlt || defaultImageAlt;
  const seoUrl = url || siteUrl;
  const robotsContent = noindex ? 'noindex, follow' : 'index, follow';

  return (
    <Helmet>
      <title>{seoTitle}</title>
      <meta name="description" content={seoDescription} />
      <meta name="keywords" content={seoKeywords} />
      <meta name="robots" content={robotsContent} />
      <meta name="author" content={productName} />
      <link rel="canonical" href={seoUrl} />

      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:image" content={seoImage} />
      <meta property="og:image:alt" content={seoImageAlt} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:url" content={seoUrl} />
      <meta property="og:site_name" content={productName} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDescription} />
      <meta name="twitter:image" content={seoImage} />
      <meta name="twitter:image:alt" content={seoImageAlt} />

      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEOHead;
